<template>
  <box-model title="农资使用量排行">
    <template v-slot:content>
      <div class="select-part">
        <select-box :sty="false" :list="selList" :item="selItem" @sel="selEvent"></select-box>
      </div>
      <div class="t-list">
        <div class="table">
          <div class="title-row flex-between">
            <div class="c-item c-title-sty">排名</div>
            <div class="c-item c-title-sty">农资名称</div>
            <div class="c-item c-title-sty">使用数量</div>
            <div class="c-item c-title-sty">单位</div>
          </div>
          <div v-if="!list.length" class="c-row" style="color: #ffffff;text-align: center;padding-top: 100px;">暂无数据</div>
          <div v-for="(item, index) in list" :key="index" class="c-row flex-between" :class="index %2 ? 'c1' : 'c2'">
            <div class="c-item c-item-sty">{{ index + 1 }}</div>
            <div class="c-item c-item-sty">{{ item.agriculturalName || '--' }}</div>
            <div class="c-item c-item-sty">{{ item.dosage || '--' }}</div>
            <div class="c-item c-item-sty">{{ item.unit || '--' }}</div>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import { statisticsFarmLogsTypeList } from "@/api/index";
  export default {
    data() {
      return {
        selList: [],
        selItem: {},

        list: []
      }
    },
    components: {
      "box-model": () => import("../../components/common/Model.vue"),
      "select-box": () => import("../../components/common/SelectBox.vue")
    },
    mounted(){
      this.getYearFn();
    },
    methods: {
      // 年份获取
      getYearFn(){
        const curYear = new Date().getFullYear();
        this.selList = [
          {name: `${curYear}年`, value: curYear},
          {name: `${curYear - 1}年`, value: curYear-1},
          {name: `${curYear - 2}年`, value: curYear-2}
        ];
        this.selItem = this.selList[0];
        this.statisticsFarmLogsTypeListFn();
      },
      selEvent(item) {
        this.selItem = item;
        this.statisticsFarmLogsTypeListFn();
      },
      statisticsFarmLogsTypeListFn(){
        statisticsFarmLogsTypeList({
          year: this.selItem.value
        }).then((res) => {
          if(!res.data){
            this.list = [];
            return;
          };
          this.list = res.data;
        });
      }
    }
  }
</script>
<style scoped lang="less">
  .select-part {
    position: absolute;
    top: -10px;
    right: 10px;
    width: 100px;
    font-size: 14px;
    font-weight: 400;
  }
  .table {
    width: 100%;
    height: 468px;
    overflow-y: scroll;
    margin-top: 20px;
    .title-row {
      width: 100%;
      height: 32px;
      background: rgba(9, 148, 255, .19);
    }
    .c-row {
      width: 100%;
      height: 40px;
    }
    .c1 {
      background: rgba(9, 148, 255, 0.14);
    }
    .c2 {
      background: rgb(2, 12, 31);
    }
    .c-item {
      width: 25%;
      height: 100%;
      font-size: 15px;
      font-weight: 400;
      color: rgba(255,255,255,0.8);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 12px;
    }
    .c-item-sty {
      line-height: 40px;
    }
    .c-title-sty {
      color: #FFFFFF;
      font-size: 14px;
      line-height: 32px;
    }
  }
</style>